import axios from "axios";
import tokenService from "./token";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
  config => {
    config.headers['Authorization'] = `bearer ${tokenService.getToken() || ''}`;
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

export default api;
